import { useEffect, useState } from 'react';
import { CheckCircle2, Check, X, RefreshCw } from 'lucide-react';
import { getMyAttendance, MyAttendance } from '../api';
import { Skeleton } from '../../../components/Skeleton';
import EmptyState from '../../../components/EmptyState';
import { colorClase } from '../../../utils/classColor';

const STATUS: Record<string, { label: string; icon: typeof Check; cls: string }> = {
  present: { label: 'Asististe', icon: Check, cls: 'text-emerald-600 dark:text-emerald-400' },
  absent: { label: 'Falta', icon: X, cls: 'text-red-600 dark:text-red-400' },
  makeup: { label: 'Reposición', icon: RefreshCw, cls: 'text-amber-600 dark:text-amber-400' },
};

function fmtDate(d: string) {
  return new Date(d.slice(0, 10) + 'T12:00:00').toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
}

export default function StudentAttendance() {
  const [data, setData] = useState<MyAttendance[] | null>(null);
  useEffect(() => { getMyAttendance().then((r) => setData(r.data)).catch(() => setData([])); }, []);

  if (!data) return <div className="space-y-3">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-14 rounded-xl" />)}</div>;

  return (
    <div className="space-y-4">
      <h1 className="font-display text-xl font-bold text-content">Mi asistencia</h1>
      {data.length === 0 ? (
        <EmptyState icon={CheckCircle2} title="Aún no hay asistencia registrada"
          subtitle="Tu historial de asistencia aparecerá aquí cuando tu profe pase lista." />
      ) : (
        <div className="divide-y divide-line/60 overflow-hidden rounded-2xl border border-line bg-surface">
          {data.map((a, i) => {
            const s = STATUS[a.status] || { label: a.status, icon: Check, cls: 'text-content-2' };
            const Icon = s.icon;
            return (
              <div key={i} className="flex items-center gap-3 px-4 py-3">
                <span className="h-8 w-1.5 rounded-full" style={{ background: colorClase(a.color) }} />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-medium text-content">{a.class_name}</div>
                  <div className="text-xs capitalize text-content-3">{fmtDate(a.date)}</div>
                </div>
                <span className={`inline-flex items-center gap-1 text-sm font-medium ${s.cls}`}><Icon size={14} /> {s.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
